import { render } from "./Artists.vue?vue&type=template&id=4818fac2&scoped=true"
import script from "./Artists.vue?vue&type=script&lang=js"
export * from "./Artists.vue?vue&type=script&lang=js"

import "./Artists.vue?vue&type=style&index=0&id=4818fac2&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4818fac2"]])

export default __exports__